class Modal {
    constructor(modalElement) {
        this.modal = modalElement;
        this.modalId = modalElement.id;
        this.closeButton = modalElement.querySelector('.modal__close');

        this.ensureInBody();
        this.bindInternalEvents();
        this.bindTriggerEvents();
    }

    ensureInBody() {
        if (this.modal.parentElement !== document.body) {
            document.body.appendChild(this.modal);
        }
    }

    bindInternalEvents() {
        this.modal.addEventListener('click', event => {
            const clickedBackdrop = event.target === this.modal;
            const clickedCloseButton = event.target.closest('.modal__close');

            if (clickedBackdrop || clickedCloseButton) {
                this.hide();
            }
        });
    }

    bindTriggerEvents() {
        document.addEventListener('click', event => {
            const trigger = event.target.closest(
                `[data-modal-target="${this.modalId}"]`
            );

            if (!trigger) return;

            event.preventDefault();
            this.show();
        });
    }

    show() {
        this.modal.classList.add('modal--show');
        document.body.style.overflow = 'hidden';

        if (this.modal.classList.contains('modal--media')) {
            this.playMedia();
        }
    }

    hide() {
        if (this.modal.classList.contains('modal--media')) {
            this.resetMedia();
        }

        this.modal.classList.remove('modal--show');

        const hasOpenModal = document.querySelector('.modal.modal--show');
        if (!hasOpenModal) {
            setTimeout(() => {
                document.body.style.overflow = '';
            }, 300);
        }
    }

    playMedia() {
        this.modal.querySelectorAll('video').forEach(v => {
            v.muted = true;
            v.play().catch(() => { });
        });

        this.modal.querySelectorAll('iframe').forEach(f => {
            let src = f.getAttribute('data-src') || f.src;
            if (!f.getAttribute('data-src')) f.setAttribute('data-src', src);
            f.src = src.includes('autoplay=1') ? src : src + (src.includes('?') ? '&' : '?') + 'autoplay=1';

            const overlay = document.createElement('div');
            overlay.style.position = 'absolute';
            overlay.style.top = 0;
            overlay.style.left = 0;
            overlay.style.width = '100%';
            overlay.style.height = '100%';
            overlay.style.backgroundColor = '#fff';
            overlay.style.zIndex = 10;
            overlay.style.transition = 'opacity 0.5s';
            if (getComputedStyle(f.parentNode).position === 'static') f.parentNode.style.position = 'relative';
            f.parentNode.appendChild(overlay);

            f.addEventListener('load', () => {
                overlay.style.opacity = 0;
                setTimeout(() => overlay.remove(), 500);
            }, { once: true });
        });
    }

    resetMedia() {
        this.modal.querySelectorAll('video').forEach(v => v.pause());
        this.modal.querySelectorAll('iframe').forEach(f => f.src = f.getAttribute('data-src') || f.src);
    }

}

document.addEventListener('DOMContentLoaded', () => {
    const modals = document.querySelectorAll('.modal');
    modals.forEach(modal => new Modal(modal));
});

/*
Estrutura HTML esperada:

<button data-modal-target="modal-1">Abrir modal</button>

<div id="modal-1" class="modal modal--lg modal--media">
  <div class="modal__content">
    <button class="modal__close">&times;</button>
    <div class="modal__body">
      <video src="video.mp4" muted></video>
    </div>
  </div>
</div>

CSS obrigatório:
.modal
.modal--show
.modal__content
.modal__close
*/
